module.exports = __webpack_public_path__ + "media/images/riders/GEE_ATHERTON-86e40f6fae46f53e6b77900a0fbb0d20.png";